import * as React from 'react';
import * as ReactGA from 'react-ga';
import './transfer.css';
import { ICaseUIState, caseInitialState } from '../Add/types/types'
import { toastr } from 'react-redux-toastr';
import { TransferCaseContainer } from './layouts/Transfer';
import * as _ from 'lodash';
import { AgenciesService } from '../../../share/services/agencies';
import { ICase } from 'src/share/types/case/case';
import { TransferService } from '../../../share/services/trasferMail';
import { ITransferMail } from 'src/share/types/case/transferMail';
import { IAgency } from 'src/share/types/agency';
import { match } from 'react-router';
import { History } from 'history';
import routes from 'src/modules/Routing/routes';


export interface ITransferProps {
    agency: IAgency;
    caseId: string;
    caseData: ICase;
    history: History;
    isLoading?: (loading: boolean) => void;
    loading: boolean;
    match: match<{ caseId: string }>;
    loadCaseData: () => void;
    permissionCase: boolean
    isAnETLCase: boolean;
}

export class TransferComponent extends React.Component<ITransferProps, ICaseUIState> {
    public transferCaseInformation: string;
    public targetAgency: string;
    public caseInfo: ICase;
    public mailInfo: ITransferMail;
    public targetAgencyContact: string[];
    constructor(props: ITransferProps) {
        super(props);
        if (this.props.permissionCase === false) {
            this.goToTranferCase()
        }
        this.state = { ..._.cloneDeep(caseInitialState), component: new Date().getTime(), isModalOpen: false };
    }

    public setValue = (path: string, value: any) => {
        return new Promise(resolve => {
            const state = { ...this.state };
            _.set(state, path, value)
            this.setState(state, () => resolve());
        })
    }

    public isInfoCase = () => this.props.match.params.caseId;

    public componentDidMount() {
        this.loadAgencies();
    }

    public getCaseId = (url) => url.split("/").pop();

    public loadAgencies = async () => {
        this.setState({ loading: true });
        try {
            const agencies = await AgenciesService.get();
            this.setState({
                loading: false,
                isEditCase: true,
                agencies: _.cloneDeep(agencies)
            });
        } catch (error) {
            toastr.error('Error', 'There was a problem loading the case');
            this.setState({ loading: false });
        }

    }

    public form = (key: string, required?: boolean) => {
        return {
            disabled: this.state.loading,
            name: key,
            required: required !== undefined ? required : true,
            value: _.get(this.props.caseData, key),
            onChange: (event) => this.setValue(key, event.currentTarget.value),
            onSelect: (event) => this.setValue(key, event.currentTarget.value)
        }
    }

    public handleSubmit = () => {
        this.setValue('submitted', true);
    }

    public handleValidSubmit = async () => {
        this.setState({ loading: true });
        try {
            this.caseInfo = _.cloneDeep(this.props.caseData);
            this.transferCaseInformation = _.cloneDeep(this.state.transferCaseInformation)
            this.targetAgency = _.cloneDeep(this.state.targetAgency)
            const currentAgency = this.props.agency;
            const targetAgencyInfo = await AgenciesService.getByID(this.targetAgency);
            this.targetAgencyContact = []
            if (currentAgency && targetAgencyInfo) {
                this.targetAgencyContact.push(targetAgencyInfo.email);
                this.mailInfo = {
                    currentAgency: {
                        name: currentAgency.name
                    },
                    caseId: `${this.caseInfo.agencyCode}-${this.caseInfo.caseId}`,
                    transferCaseInformation: this.transferCaseInformation,
                    targetAgency: {
                        name: targetAgencyInfo.name,
                        code: targetAgencyInfo.code,
                        agencyContact: this.targetAgencyContact,
                    },
                    isPublic: this.caseInfo.public
                }
                await this.save(this.mailInfo);
                ReactGA.event({
                    category: 'Case',
                    action: ' Transfer case',
                    label: 'Cases management'
                });
                await this.props.loadCaseData();
                this.setState({ loading: false });
                toastr.success('Cross-border', `The agency has been added to the case`);
                this.goToTranferCase()
            }
        } catch (error) {
            toastr.error('Error', 'There was a problem sending the mail');
            this.setState({ loading: false });
        }
    }
    public goToTranferCase() {
        this.props.history.push(routes.TRANSFERCASE.replace(':caseId', this.props.caseId))
    }

    public async save(mailInfo: ITransferMail) {
        await TransferService.sendData(mailInfo);
    }

    public render() {
        return <TransferCaseContainer that={this} />
    }
}

export default TransferComponent;


// WEBPACK FOOTER //
// ./src/modules/Case/TransferCase/Transfer.tsx